document.addEventListener('DOMContentLoaded', function () {
  var option_select = document.getElementById("blog-select");
  var filter = document.getElementById("blog-filter");

  if (!filter) {
    option_select = document.getElementById("careers-select");
    filter = document.getElementById("careers-filter");
  }

  if (option_select && filter) {
    option_select.onchange = function () {
      filter.submit();
    };
  }
});